export const TRANSPORT_TYPE_FCL = 'fcl'
export const TRANSPORT_TYPE_LCL = 'lcl'

type TTransportTypeFcl = typeof TRANSPORT_TYPE_FCL
type TTransportTypeLcl = typeof TRANSPORT_TYPE_LCL

export type TTransportType = TTransportTypeFcl | TTransportTypeLcl

export const TRANSPORT_TYPES = [TRANSPORT_TYPE_FCL, TRANSPORT_TYPE_LCL]
